import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useState } from "react";

const Navbar = () => {
    const [showInterviewModal, setShowInterviewModal] = useState(false);
    const [isInterviewImageLoading, setIsInterviewImageLoading] = useState(false);

    const openInterviewModal = () => {
        setIsInterviewImageLoading(true);
        setShowInterviewModal(true);
    };

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            <div className="top-header-area">
                <div className="">
                    <div className="row align-items-center">
                        <div className="col-lg-4">
                            <marquee behavior="scroll" direction="left" scrollamount="5">
                                <button
                                    type="button"
                                    className="border border-0 bg-transparent text-black p-0 "
                                    onClick={openInterviewModal}
                                >
                                    📢 Walk in interviews for all teaching and non-teaching positions from 8th September to 11th September. For more details <strong>click here.</strong>
                                </button>
                            </marquee>
                        </div>
                        <div className="col-lg-8 d-none d-xl-block">
                            <div className="header-right-content">
                                <div className="list">
                                    <ul className=''>
                                        <li className="admissionBtn m-0 " style={{ marginRight: "0" }}>
                                            <a target="_blank" className="text-white" href="https://www.aicte.gov.in/schemes/students-development-schemes"><strong>  AICTE Scholarship/Fellowship Schemes </strong></a>
                                        </li>
                                        <li className="clubsCode m-0 " style={{ marginRight: "0" }}>
                                            <Link to="/nirf"><strong>  NIRF </strong></Link>
                                        </li>
                                        <li className="nirf">
                                            <Link to="/NAACLogin"><strong>NAAC</strong></Link>
                                        </li>
                                        <li className="clubsCode m-0" style={{ marginLeft: "0px" }}>
                                            <Link to="/NAAC-AQAR/2023-24" style={{ background: "#61abdf" }}><strong>NAAC AQAR</strong></Link>
                                        </li>
                                        <li className="clubsCode m-0 sm-small-text" style={{ marginRight: "0" }}>
                                            <a href="#"> Eamcet Code :<strong>  SDEW </strong></a>
                                        </li>
                                        <li className=" eamcetCode m-0 sm-small-text">
                                            <a href="https://sites.google.com/view/swecclubs?pli=1" target="_blank"> SWEC Clubs</a>
                                        </li>
                                        <li className="login-icon text-black m-0">
                                            <a className="h4 text-black sm-small-text"
                                                href="http://ecap.swec.ac.in/Default.aspx?ReturnUrl=%2f"
                                                target="_blank">
                                                <strong>&nbsp; ECAP Login</strong></a>
                                        </li>

                                        <li className="admissionBtn">
                                            <a href="https://erp.swec.ac.in/" className="sm-small-text" target='_blank'><strong>
                                                &nbsp;Results</strong></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="navbar-area nav-bg-2 d-none d-lg-block">
                <div className="mobile-responsive-nav">
                    <div className="container">
                        <div className="mobile-responsive-menu">
                            <div className="logo">
                                <Link to="/">
                                    <img src="https://admin.swec.ac.in/assetsswec/images/Logo.png" className="main-logo" alt="Sridevi Engineeing college logo" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="desktop-nav">
                    <div className="px-lg-5">
                        <nav className="navbar navbar-expand-md navbar-light">
                            <Link to="/" className="navbar-brand" href="#">
                                <img src="https://admin.swec.ac.in/assetsswec/images/Logo.png" className="main-logo" alt="logo" />

                            </Link>
                            <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">

                                <ul className="navbar-nav mx-auto ">
                                    <li className="nav-item">
                                        <Link to="/" className="nav-link  fw-bold active">
                                            Home
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#" className="nav-link  fw-bold dropdown-toggle ">
                                            About
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link to="/about/about-college" className="nav-link">About College</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/management" className="nav-link dropdown-item">Management</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/admissions" className="nav-link">Admissions</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/recognitions" className="nav-link dropdown-item">Approvals and Accreditations</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/iso-certificate" className="nav-link dropdown-item">ISO Certificate</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/aicte" className="nav-link dropdown-item">AICTE Subsequent Approval Letters</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/jntuh-approval" className="nav-link dropdown-item">JNTUH Approval Letters</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/governing-body" className="nav-link dropdown-item">Governing Body</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/policy" className="nav-link dropdown-item">Policy</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/academic-council" className="nav-link dropdown-item">
                                                    Academic Council
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/adviser" className="nav-link dropdown-item">Advisor</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/principal" className="nav-link dropdown-item">Principal</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/dean-academics" className="nav-link dropdown-item">Dean Academics</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/dean-admissions" className="nav-link dropdown-item">Dean Admissions</Link>
                                            </li>
                                            {/* <li className="nav-item">
                                                <Link to="/about/board-of-studies" className="nav-link dropdown-item">Board of Studies (BoS)</Link>
                                            </li> */}
                                            <li className="nav-item">
                                                <Link to="/about/committee" className="nav-link dropdown-item">Committees</Link>
                                            </li>
                                            {/* <li>
                                        <Link to="/about/Committees-MoM/2025-26" className="nav-link dropdown-item">Committee MoM</Link>
                                    </li> */}

                                            <li className="nav-item">
                                                <Link to="/about/mandatory-disclosure" className="nav-link dropdown-item">Mandatory Disclosure</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/audit-reports" className="nav-link dropdown-item">Audit Reports</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/service-rules" className="nav-link dropdown-item">Service Rules</Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link to="/about/organogram" className="nav-link dropdown-item">Organogram</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/about/salient-features" className="nav-link dropdown-item">Salient Features</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#" className="nav-link fw-bold dropdown-toggle">
                                            Academics
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link to="/academic-overview" className="nav-link dropdown-item">Academic Overview</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/best-practices" className="nav-link dropdown-item">Best Practices</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/institute-distinctiveness" className="nav-link dropdown-item">Institute Distinctiveness</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/academic-programs" className="nav-link dropdown-item">Academic Programs</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/cse" className="nav-link dropdown-item">CSE- Computer Science </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/cse-ds/" className="nav-link dropdown-item" >CSD - Data Science </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/ai-ml/" className="nav-link dropdown-item">CSM - Artificial Intelligence and <br /> Machine Learning
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/ece/" className="nav-link dropdown-item">Electronics and Communication <br /> Engineering (ECE)</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/ece/" className="nav-link dropdown-item">ECE (VLSI design & Technology )</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/it/" className="nav-link dropdown-item">Information Technology (IT)</Link>
                                            </li>
                                            {/* <li className="nav-item">
                                                <Link to="/dept/eee/" className="nav-link dropdown-item">Electrical and Electronics <br /> Engineering (EEE)</Link>
                                            </li> */}
                                            <li className="nav-item">
                                                <Link to="/dept/mba/" className="nav-link dropdown-item">Master of Business Administration </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/mca/" className="nav-link dropdown-item">Master of Computer Applications </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/m-tech/" className="nav-link dropdown-item">M.Tech Department</Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link to="/dept/mca/" className="nav-link dropdown-item">MCA Department</Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link to="/dept/s-and-h/" className="nav-link dropdown-item">S&H Department</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/e-learning-resources" className="nav-link dropdown-item">E-Learning Resources</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/dpe/" className="nav-link dropdown-item">Department of Physical Education</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/dept/library/" className="nav-link dropdown-item">Library Department</Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="nav-item ">
                                        <a href="#" className="nav-link dropdown-toggle fw-bold">
                                            Research
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link to="/r-and-d/overview" className="dropdown-item">Overview</Link>
                                            </li>
                                            <li>
                                                <Link to="/r-and-d/innovation-incubation/" className="dropdown-item">Innovation &amp; Incubation</Link>
                                            </li>
                                            <li>
                                                <Link to="/r-and-d/team" className="dropdown-item">Research Team</Link>
                                            </li>
                                            <li>
                                                <Link to="/r-and-d/grants-received/" className="dropdown-item">Grants received</Link>
                                            </li>
                                            <li>
                                                <Link to="/r-and-d/research-guide/" className="dropdown-item">Research guide</Link>
                                            </li>
                                            <li>
                                                <Link to="/r-and-d/industry-institute-interaction/" className="dropdown-item">Industry Institute
                                                    Interaction</Link>
                                            </li>

                                        </ul>
                                    </li>
                                    <li className="nav-item ">
                                        <Link to="/Innovation" className="nav-link fw-bold">
                                            Innovation
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#" className="nav-link fw-bold dropdown-toggle">
                                            IQAC
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link to="/iqac/quality-policy/" className="dropdown-item">Quality Policy</Link>
                                            </li>
                                            <li>
                                                <Link to="/iqac/quality-education/" className="dropdown-item">Quality Education</Link>
                                            </li>
                                            <li>
                                                <Link to="/iqac/" className="dropdown-item">IQAC</Link>
                                            </li>

                                        </ul>
                                    </li>
                                    <li className="nav-item ">
                                        <Link to="/training-and-placements/" className="nav-link fw-bold">
                                            Training & Placement
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#" className="nav-link dropdown-toggle fw-bold">
                                            Examination Cell
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link className="dropdown-item" to="/academics-calendar/">JNTUH</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to="/autonomous-syllabus">Autonomous</Link>
                                            </li>

                                        </ul>
                                    </li>
                                </ul>
                                <div className="others-options d-none">
                                    <div className="icon">
                                        <i className="ri-menu-3-fill" data-bs-toggle="modal" data-bs-target="#sidebarModal"></i>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
                <div className="others-option-for-responsive">
                    <div className="container">
                        <div className="dot-menu">
                            <div className="inner">
                                <div className="icon">
                                    <i className="ri-menu-3-fill" data-bs-toggle="modal" data-bs-target="#sidebarModal"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-none d-lg-block nav-bg-2 secondNavbar navbar-area justify-content-end ">
                <nav className="navbar navbar-expand-lg py-0">
                    <div className="mx-auto">

                        <div className="collapse navbar-collapse" id="navbarNavDropdown">
                            <ul className="navbar-nav" >
                                <li className="nav-item fw-bold text-warning" >
                                    <Link to="/college-video" className="nav-link text-yellow"  >
                                        <span className='text-yellow'>College Video</span>
                                    </Link>
                                </li>
                                <li className="nav-item afterarrow">
                                    <a className="nav-link dropdown-toggle fw-bold" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Infrastructure
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li className="text-black">
                                            <Link to="/infrastructure/central-facilities">Central Facilities</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/physically-handicapped">Physically Handicapped  Facilities</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/transport">Transport Facility</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/parking">Parking Facility</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/computer-centre">Computer Centre</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/swec-campus-hostel">SWEC Campus Hostel</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/ict">ICT</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/green-initiatives">Green Initiatives</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/sustainable-development-goals">Sustainable Development Goals</Link>
                                        </li>
                                        <li className="text-black">
                                            <Link to="/infrastructure/certification">
                                                Infrastructure Certificates
                                            </Link>
                                        </li>
                                        {/* <li className="text-black">
                                            <Link to="/infrastructure/sports">
                                                Sports
                                            </Link>
                                        </li> */}
                                        <li className="text-black">
                                            <Link to="/infrastructure/photos">
                                                Infrastructure &amp; Facilities Photos
                                            </Link>
                                        </li>
                                    </ul>


                                </li>

                                {/* <li className="nav-item fw-bold">
                                    <Link to="/Innovation-EDC" className="nav-link">EDC </Link>
                                </li> */}
                                <li className="nav-item fw-bold">
                                    <Link to="/professional-societies/" className="nav-link">Professional Societies</Link>
                                </li>
                                <li className="nav-item fw-bold">
                                    <Link to="/alumni/2024-25/" className="nav-link">Alumni </Link>
                                </li>
                                <li className="nav-item fw-bold">
                                    <Link to="/grievance-cell/" className="nav-link">Grievance Cell </Link>
                                </li>
                                <li className="nav-item fw-bold">
                                    <Link to="/testimonials/" className="nav-link">Testimonials </Link>
                                </li>
                                <li className="nav-item fw-bold">
                                    <Link to="/feedback/" className="nav-link">Feedback</Link>
                                </li>

                                <li className="nav-item dropdown ">
                                    <a className="nav-link dropdown-toggle fw-bold" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Activities
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/activities/GreenCampus/">Green Campus</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/activities/it-finishing-school/">IT Finishing School</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/activities/obe/">OBE</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/activities/ncc/">NCC</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/activities/nss/">NSS</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/activities/sswec/">SSWEC</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/activities/college-magazine/">College Magazine</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item ">
                                    <a href="#" className="nav-link dropdown-toggle fw-bold" >
                                        News & Events
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/news-and-events/news">News</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/news-and-events/events">Events</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/news-and-events/gallery" >Student’s Gallery</Link>
                                        </li>
                                        {/* <li>
                                                <Link className="dropdown-item" to="/news-and-events/circulars">Circulars</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to="/news-and-events/swec-radio">SWEC Radio</Link>
                                            </li> */}
                                    </ul>
                                </li>


                                <li className="nav-item fw-bold">
                                    <Link to="/contact-us/" className="nav-link">Contact Us</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <div className="others-option-for-responsive">
                    <div className="container">
                        <div className="dot-menu">
                            <div className="inner">
                                <div className="icon">
                                    <i className="ri-menu-3-fill" data-bs-toggle="modal" data-bs-target="#sidebarModal"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Navbar Start*/}
            <nav className="navbar navbar-expand-lg bg-body-tertiary d-block d-lg-none mobileNavba">
                <div className="container-fluid">
                    <Link to="/">
                        <img src="https://admin.swec.ac.in/assetsswec/images/Logo.png" className="main-logo" alt="logo" />
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="fa-sharp fa-solid fa-bars"></i>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <Link to="/" className="nav-link active">
                                    Home
                                </Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a href="#" className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    About
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/about/about-college" className="nav-link dropdown-item">About College</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/management" className="nav-link dropdown-item">Management</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/admissions" className="nav-link dropdown-item">Admissions</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/recognitions" className="nav-link dropdown-item">Approvals and Accreditations</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/iso-certificate" className="nav-link dropdown-item">ISO Certificate</Link>
                                    </li>
                                    <li >
                                        <Link to="/about/aicte" className="nav-link dropdown-item">AICTE Subsequent Approval Letters</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/governing-body" className="nav-link dropdown-item">Governing Body</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/policy" className="nav-link dropdown-item"> Policy</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/adviser" className="nav-link dropdown-item">Adviser</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/principal" className="nav-link dropdown-item">Principal</Link>
                                    </li>

                                    <li>
                                        <Link to="/about/Committee" className="nav-link dropdown-item">Committees</Link>
                                    </li>

                                    {/* <li>
                                        <Link to="/about/Committees-MoM/2025-26" className="nav-link dropdown-item">Committee MoM</Link>
                                    </li> */}

                                    <li>
                                        <Link to="/about/mandatory-disclosure" className="nav-link dropdown-item">Mandatory Disclosure</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/service-rules" className="nav-link dropdown-item">Service Rules </Link>
                                    </li>

                                    <li>
                                        <Link to="/about/organogram" className="nav-link dropdown-item">Organogram</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/salient-features" className="nav-link dropdown-item">Salient Features</Link>
                                    </li>

                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    Departments
                                </a>
                                <ul className="dropdown-menu">
                                    <li className="nav-item">
                                        <Link to="/dept/cse" className="nav-link dropdown-item">Computer Science and Engineering(CSE)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/cse-ds/" className="nav-link dropdown-item">CSE &amp; Data Science (CSE- DS)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/ai-ml/" className="nav-link dropdown-item"> CSE &amp; Artificial Intelligence and Machine Learning
                                            (CSE &amp;
                                            AI&amp;ML)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/ece/" className="nav-link dropdown-item">Electronics and Communication Engineering(ECE)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/ece/" className="nav-link dropdown-item">ECE (VLSI design & Technology )</Link>
                                    </li>

                                    <li className="nav-item" >
                                        <Link to="/dept/it/" className="nav-link dropdown-item">Information Technology(IT)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/eee/" className="nav-link dropdown-item">Electrical and Electronics Engineering(EEE)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/mba/" className="nav-link dropdown-item">Master of Business Administration(MBA)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/mca/" className="nav-link dropdown-item">Master of Computer Applications(MCA)</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/m-tech/" className="nav-link dropdown-item">M.Tech Department</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/s-and-h/" className="nav-link dropdown-item">S&amp;H Department</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/dpe/" className="nav-link dropdown-item" >Department of Physical Education</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/dept/library/" className="nav-link dropdown-item">Library Department</Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    IQAC
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/iqac/quality-policy/" className="dropdown-item">Quality Policy</Link>
                                    </li>
                                    <li>
                                        <Link to="/iqac/quality-education/" className="dropdown-item">Quality Education</Link>
                                    </li>
                                    <li>
                                        <Link to="/iqac/" className="dropdown-item">IQAC</Link>
                                    </li>

                                </ul>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    R & D
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/r-and-d/innovation-incubation/" className="dropdown-item">Innovation &amp; Incubation</Link>
                                    </li>
                                    <li>
                                        <Link to="/r-and-d/grants-received/" className="dropdown-item">Grants received</Link>
                                    </li>
                                    <li>
                                        <Link to="/r-and-d/research-guide/" className="dropdown-item">Research guide</Link>
                                    </li>
                                    <li>
                                        <Link to="/r-and-d/industry-institute-interaction/" className="dropdown-item">Industry Institute
                                            Interaction</Link>
                                    </li>

                                </ul>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Examination Cell
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a className="dropdown-item" href="academics.html">JNTUH</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="autonomous-syllabus.html">Autonomous</a>
                                    </li>

                                </ul>
                            </li>

                            <li className="nav-item">
                                <Link to="/training-and-placements/" className="nav-link">
                                    Training & Placement
                                </Link>

                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    News & Events
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to="/news-and-events/news">News</Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/news-and-events/events" >Events</Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/news-and-events/gallery">Student’s Gallery</Link>
                                    </li>
                                    {/* <li>
                                        <Link className="dropdown-item" to="/news-and-events/circulars">Circulars</Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/news-and-events/swec-radio">SWEC Radio</Link>
                                    </li> */}
                                </ul>
                            </li>

                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Activities
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to="/activities/obe/">OBE</Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/activities/ncc/">NCC</Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/activities/nss/">NSS</Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/activities/sswec/">SSWEC</Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/activities/college-magazine/">College Magazine</Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/contact-us/" className="nav-link">Contact Us</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Mobile Navbar End*/}



            {/* Nav Bottom start                                         */}

            <div className="top-header-area">
                <div className="">
                    <div className="row align-items-center">

                        <div className="col d-block d-md-none">
                            <div className="header-right-content">
                                <div className="list">
                                    <ul className=''>
                                        {/* <li className="text-white align-items-center pt-1 text-black m-0">
                                            <span className='text-black'> Accredited by NBA & NAAC (A++) </span>&nbsp;&nbsp;
                                        </li> */}
                                        {/* <li className="nirf">
                                            <Link to="/NAACLogin"><strong>NAAC</strong></Link>
                                        </li> */}
                                        {/* <li className="clubsCode m-0" style={{marginLeft:"0px"}}>
                                            <Link to="/NAAC-AQAR" style={{background:"#61abdf"}}><strong>NAAC AQAR</strong></Link>
                                        </li> */}
                                        <li className="clubsCode m-0 " style={{ marginRight: "0" }}>
                                            <a href="#"> Eamcet Code :<strong>  SDEW </strong></a>
                                        </li>
                                        <li className=" eamcetCode m-0">
                                            <a href="https://sites.google.com/view/swecclubs?pli=1" target="_blank"> SWEC Clubs</a>
                                        </li>
                                        {/* <li className="naacCode" >
                                            <a href="/NAACLogin"> NAAC</a>
                                        </li> */}

                                        <li className="login-icon text-black m-0">
                                            <a className="h4 text-black"
                                                href="http://ecap.swec.ac.in/Default.aspx?ReturnUrl=%2f"
                                                target="_blank">
                                                {/* <i className="fa-regular fa-envelope"></i> */}
                                                <strong>&nbsp; ECAP Login</strong></a>
                                        </li>

                                        <li className="admissionBtn">
                                            <a href="https://erp.swec.ac.in/" target='_blank'><strong>
                                                {/* <i className="fa-solid fa-right-to-bracket"></i> */}
                                                &nbsp;Results</strong></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Nav Bottom ends                                        */}






            <div className="icon-float">
                <ul>
                    {/* <li>
                        <div className="admissionBtn">
                            <Link to="/admissions/b-tech-category-b-2025/" className="btn btn-primary rounded-0 fw-bold">
                                Admissions Open
                            </Link>
                        </div>
                    </li> */}
                    <li>
                        <a href="https://www.facebook.com/sweccollege/" target="_blank" className="fb1"><i className="fa-brands fa-facebook"></i></a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/swecofficial" target="_blank" className="insta"><i className="fa-brands fa-instagram"></i></a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/srideviengg/" target="_blank" className="li1"><i className="fa-brands fa-linkedin"></i></a>
                    </li>
                </ul>
            </div>

            {/* <div class="swec-tooltip-wrapper">
                <button class="swec-hover-me swec-star-icon-button">We did it<br />  again!! 🎈</button>
                <img src="/assets/click.gif" alt="Click" class="click-gif" />
                <div class="swec-tooltip">
                    <span class="swec-star">⭐</span>
                    <span class="swec-star">⭐</span>
                    <span class="swec-star">⭐</span>
                    We are proud to announce that Sridevi Women's Engineering College got re-accredited for the third time by NBA from 2025-26 to 2027-28 for all eligible engineering programs.
                </div>
            </div> */}

            <div className="go-top active scrollToTop" onClick={handleClick}>
                <i className="fa fa-angle-up"></i>
                <i className="fa fa-angle-up"></i>
            </div>

            <Modal
                show={showInterviewModal}
                onHide={() => setShowInterviewModal(false)}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Walk-in Interviews</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-2 p-md-3">
                    {isInterviewImageLoading && (
                        <div className="d-flex justify-content-center align-items-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading image...</span>
                            </div>
                        </div>
                    )}
                    <img
                        src="https://admin.swec.ac.in/assetsswec/img/walk-in-interviews-08-09-2026.jpeg"
                        alt="Walk-in interviews announcement"
                        className={`img-fluid${isInterviewImageLoading ? " d-none" : ""}`}
                        onLoad={() => setIsInterviewImageLoading(false)}
                    />
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default Navbar

